import React from 'react';

/**
 * Micro-label above a heading or at the top of a card.
 *
 * BRAND-SPEC.md "Type": 12px Public Sans, uppercase, tracking 0.16em to 0.2em,
 * in --text-3. The design reference uses 0.2em at section level and 0.16em
 * inside a card.
 *
 * Colour comes from `text-caption`, which resolves --text-3 through the
 * cascade. Card's reversed variant rebinds --text-3 on its own element, so the
 * same component reads correctly on sand and on ink blue with no extra prop.
 */

interface EyebrowProps {
  /** 'section' is 0.2em. 'card' is the tighter 0.16em used inside a Card. */
  tracking?: 'section' | 'card';
  className?: string;
  children: React.ReactNode;
}

export default function Eyebrow({
  tracking = 'section',
  className = '',
  children,
}: EyebrowProps) {
  const trackingClass = tracking === 'card' ? 'tracking-[0.16em]' : 'tracking-[0.2em]';

  return (
    <p className={`font-sans text-xs uppercase text-caption ${trackingClass} ${className}`.trim()}>
      {children}
    </p>
  );
}
